<button
  class="filter-btn relative h-[50px] w-[50px]"
  sharedCoreButton
  #menuTrigger="element"
  provideNativeElement
  #floatingMenuAnchor
  (click)="toggleFilterMenu($event)">
  <img [ngSrc]="'@shared-core/icons/filter_icon.svg'" [width]="18" [height]="18" alt="" />
  <span
    [ngClass]="{ invisible: !anyFilterApplied() }"
    class="absolute aspect-square rounded-xl bg-red-500 px-2"></span>
</button>

<shared-core-floating-menu
  [anchor]="floatingMenuAnchor"
  [placement]="'bottom-start'"
  [isOpened]="isOpen()"
  [offsetConfig]="{ main: 10, cross: crossOffset() }"
  (outsideClick)="hide()"
  [class.hidden]="!isOpen()"
  [trigger]="menuTrigger"
  class="fixed z-20">
  <shared-core-floating-menu-item
    class="shadow-floating-container absolute w-[300px] rounded-xl bg-white py-4 text-base text-nowrap">
    <div
      class="border-b-theme-light-gray flex w-full items-center justify-between border-b px-2 pb-2">
      <span class="font-bold">Filter</span>
      <button (click)="hide()">
        <shared-core-material-icon [name]="'close'" />
      </button>
    </div>
    <div class="border-b-theme-light-gray flex flex-col items-start gap-y-2 border-b p-2">
      <span class="font-bold">Dokumentenklasse</span>
      @for (checkbox of documentClassCheckboxes(); track $index) {
        <shared-ui-checkbox [checkbox]="checkbox" />
      }
    </div>
    <div class="flex items-center justify-between gap-x-4 px-2 pt-2">
      <button
        sharedCoreButton
        class="h-full w-full !border-0 !font-normal !normal-case"
        (click)="onResetFilterClicked()">
        <span>Filter entfernen</span>
      </button>
      <button
        sharedCoreButton
        (click)="onApplyFilter()"
        class="h-full w-full !font-normal !normal-case">
        <span>Filter anwenden</span>
      </button>
    </div>
  </shared-core-floating-menu-item>
</shared-core-floating-menu>
